import { Capacitor } from '@capacitor/core';
export function useSafeArea() {
    if (Capacitor.platform === 'android') {
        return 40;
    }
    return;
}
//# sourceMappingURL=useSafeArea.js.map